import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "text-center fs-6 fw-bolder mb-1",
  style: {"font-size":"0.7rem"}
}
const _hoisted_2 = {
  class: "text-center",
  style: {"font-size":"0.7rem"}
}
const _hoisted_3 = {
  key: 0,
  class: "h-20"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center font-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.nguoiKy), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.thongTin), 1),
    (_ctx.name)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.name)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.name), 1))
      : _createCommentVNode("", true)
  ], 64))
}